
import { useParams } from "react-router-dom";
import { useAccount } from "wagmi";
import Header from "@/components/Header";
import ProfileHeader from "@/components/profile/ProfileHeader";
import ProfileTabs from "@/components/profile/ProfileTabs";
import SentryTest from "@/components/profile/SentryTest";
import { useProfileData } from "@/hooks/useProfileData";

const Profile = () => {
  const { address } = useParams();
  const { address: currentUserAddress } = useAccount();
  
  const shortAddress = address ? `${address.slice(0, 6)}...${address.slice(-4)}` : "";
  const fullAddress = address || "";
  
  // Check if current user is viewing their own profile
  const isOwnProfile = currentUserAddress && currentUserAddress.toLowerCase() === address?.toLowerCase();

  const { 
    profile, 
    coins,
    heldCoins,
    isLoading, 
    error
  } = useProfileData({
    address,
    shortAddress,
    isOwnProfile,
    currentUserAddress
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="mb-4">
          <SentryTest currentUserAddress={currentUserAddress} />
        </div>

        {error && (
          <div className="mb-4 p-4 bg-destructive/10 text-destructive rounded-md">
            {error}
          </div>
        )}

        <ProfileHeader 
          profile={profile}
          isOwnProfile={isOwnProfile}
          shortAddress={shortAddress}
          fullAddress={fullAddress}
          coinCount={coins.length}
          address={address}
        />

        <ProfileTabs 
          isLoading={isLoading}
          coins={coins}
          heldCoins={heldCoins}
        />
      </main>
    </div>
  );
};

export default Profile;
